<div *ngIf="state === 'ready'">
    <div class="row">        
        <div class="col-1">
            <a (click)="openViewInfoEditPanel(0)" ngbTooltip="Add">
                <i class="fa fa-plus" style="color: blue"></i>
            </a>
        </div>
    </div>
    <hr/>
    <div *ngIf="state === 'ready'" class="tcc-table-div">
        <tcc-table tableClass="table-sm small" 
            [rows]="viewInfos" 
            [columns]="columns" 
            [buttons]="buttons"
            (cellClick)="rowClicked($event)">
        </tcc-table>
    </div>
</div>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>